module.exports = __webpack_public_path__ + "static/media/04baojieyuan2.daa8bc42.png";